export const FORM_EDIT = ({ disabledSo }: any) => {
  return [
    {
      ref: "reserveId",
      name: "reserveId",
      type: "INPUT",
      label: "หมายเลขการจอง",
      placeholder: "ตัวอย่าง DRSH2205-0019",
      span: 12,
      readOnly: true,
    },
    {
      ref: "customerName",
      name: "customerName",
      label: "ชื่อลูกค้า",
      type: "INPUT",
      placeholder: "ตัวอย่าง BRX-102",
      span: 12,
      readOnly: true,
    },
    {
      ref: "customerCode",
      name: "customerCode",
      label: "รหัสลูกค้า",
      type: "INPUT",
      placeholder: "ตัวอย่าง TBK-NMI-22-0004",
      span: 12,
    },
    {
      ref: "createDate",
      name: "createDate",
      label: "วันที่จอง",
      placeholder: "วันที่จอง",
      type: "INPUT",
      span: 12,
      readOnly: true,
    },
    {
      ref: "saleOrder",
      name: "saleOrder",
      label: "รหัส SO",
      type: "INPUT",
      span: 8,
    },
    {
      ref: "invoiceId",
      name: "invoiceId",
      label: "รหัส Invoice",
      type: "INPUT",
      span: 8,
    },
    {
      ref: "saleLotId",
      name: "saleLotId",
      label: "เลข Lot",
      type: "INPUT",
      span: 8,
    },
    {
      ref: "versionMachine",
      name: "versionMachine",
      label: "version เครื่องตัด",
      type: "INPUT",
      span: 12,
      readOnly: true,
    },
    {
      // เงื่อนไข = แสดงอย่างเดียว (ไม่ให้เลือกใหม่) → ใช้ชื่อ reserveType, reserveTypeId ยังส่งตอน confirm
      ref: "reserveType",
      name: "reserveType",
      label: "เงื่อนไข",
      type: "INPUT",
      span: 12,
      readOnly: true,
    },
    {
      ref: "exchangeCondition",
      name: "exchangeCondition",
      label: "เงื่อนไขการแลก",
      type: "TEXTAREA",
      span: 24,
      readOnly: true,
    },
  ];
};

export const FORM_SEARCH = ({ onSubmitSearch, optionsReserve }: any) => {
  return [
    {
      ref: "search_reserveId",
      name: "search_reserveId",
      type: "INPUT",
      label: "หมายเลขการจอง",
      placeholder: "ตัวอย่าง DRSH2205-0019",
      span: 6,
      onEnter: onSubmitSearch,
    },
    {
      ref: "search_saleCode",
      name: "search_saleCode",
      label: "รหัสเซลล์",
      type: "INPUT",
      placeholder: "ตัวอย่าง BRX-102",
      span: 6,
      onEnter: onSubmitSearch,
    },
    {
      ref: "search_customerCode",
      name: "search_customerCode",
      label: "รหัสลูกค้า",
      type: "INPUT",
      placeholder: "ตัวอย่าง TBK-NMI-22-0004",
      span: 6,
      onEnter: onSubmitSearch,
    },
    {
      ref: "search_reserveDate",
      name: "search_reserveDate",
      label: "วันที่จอง",
      placeholder: "วันที่จอง",
      type: "DATEPICKER",
      span: 6,
    },
    {
      ref: "search_reservationOption",
      name: "search_reservationOption",
      id: "search_reservationOption",
      label: "สถานะ",
      type: "SELECT",
      span: 6,
      properties: {
        options: optionsReserve,
        valueKey: "value",
        labelKey: "label",
      },
    },
  ];
};